import { Directive, AfterViewInit, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[autoFocusForm]'  // directive applied via attribute
})
export class AutofocusFormDirective {
    @Input() autofocusForm = true; // optional input to enable/disable

    constructor(private el: ElementRef<HTMLFormElement>) {}

    ngOnChanges(): void {
        if (!this.autofocusForm) return;

        setTimeout(() => {
            // Find the first element inside the form with 'autofocus' attribute
            const first = this.el.nativeElement.querySelector('[autofocus]') as HTMLElement | null;
            // preventScroll: het focussen mag de (onder .scroll-ready scrollbare) details-sectie
            // niet in beeld scrollen; dat zou de tab→edit-overgang laten verspringen en de
            // compact-box-fade onderbreken. Het eerste veld staat na de overgang toch bovenaan.
            if (first) first.focus({ preventScroll: true });
        }, 0);
    }
}